module.exports = __webpack_public_path__ + "img/pic_appIcon.152d63b3.png";